import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '@material-ui/lab/Pagination';

import './index.css';

import { formatDate, paginationStyle } from './index';

import { getErrorLogs } from '../../../../../store/actions/reports';
import { BotsCreators } from '../../../../../store/actions/bots';

import ErrorLogsDropdown from './components/ErrorLogsDropdown';
import ErrorLogsTable from './components/ErrorLogsTable';
import FilterData from '../../../../../components/FilterAnalyze/FilterData/FilterData';
import itemsTypes from '../../../../../util/itemsTypes';

const botActions = BotsCreators;

const ErrorLogs = (factory, deps) => {
  const filter = useSelector((state) => state?.filter);
  const bot = useSelector((state) => state?.bots?.bot);
  const timezone = useSelector((state) => state?.bots?.bot?.settings?.timezone);
  const bots = useSelector((state) => state?.bots?.list);
  const errorLogs = useSelector((state) => state?.reports?.errorLogs);

  const [startDate, setStartDate] = useState(filter?.startDate);
  const [endDate, setEndDate] = useState(filter?.endDate);
  const [checkedItemsTypes, setCheckedItemsTypes] = useState([]);
  const [itemsTypesFilter, setItemsTypesFilter] = useState([]);
  const [sessionId, setSessionId] = useState('');

  const dispatch = useDispatch();
  const classes = paginationStyle();

  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = filter;
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, [filter]);

  const buildErrorLogData = (page) => {
    const { nameTags: tags, channels, variables } = filter;
    const { _id: botId } = bot;

    return {
      ...formatDate({ startDate, endDate, timezone }),
      ...(sessionId && sessionId !== '' && { session_id: sessionId }),
      ...(Array.isArray(itemsTypesFilter) &&
        itemsTypesFilter.length > 0 && { items_types: itemsTypesFilter }),
      ...(Array.isArray(variables) &&
        variables.length > 0 && { variables: JSON.stringify(variables) }),
      timezone: timezone?.fuso,
      bots: [botId],
      tags,
      channels,
      page,
      limit: errorLogs?.limit,
    };
  };

  useEffect(() => {
    if (!Array.isArray(bots) || bots.length <= 0) {
      dispatch(botActions.listBotsRequest());
    }

    if (bot) {
      const data = buildErrorLogData(errorLogs?.page);
      dispatch(getErrorLogs(data));
    }
  }, []);

  const getPage = (event, page) => {
    const data = buildErrorLogData(page);
    dispatch(getErrorLogs(data));
  };

  const onClickFilter = async () => {
    const data = buildErrorLogData(1);
    dispatch(getErrorLogs(data));
  };

  const onChangeSessionIdInput = (event) => {
    event.preventDefault();
    setSessionId(event.target.value);
  };

  const formatItemsTypeSDropdownOptions = useMemo(() => {
    return itemsTypes.map(({ type, name }) => ({ _id: type, name, type }));
  }, []);

  const formatItemsTableData = () => {
    return errorLogs.docs.map((doc) => {
      const {
        botId,
        itemType,
        httpCode,
        description,
        when,
        sessionId: session,
      } = doc;
      const currentBot = bots?.find(({ _id }) => String(_id) === String(botId));
      const formattedItemType = itemsTypes.find(
        ({ type }) => String(type) === String(itemType)
      );
      return {
        ...doc,
        botName: currentBot?.title || '',
        itemType: formattedItemType?.name || '',
        details: 'Detalhes',
        sessionId: session,
        errorType: httpCode,
        date: when,
        description,
      };
    });
  };

  return (
    <div className="error-logs-page-content">
      <div className="error-logs-page-filters">
        <div className="error-logs-page-filters-options">
          <div className="container-period-selector">
            <FilterData onClickFilter={onClickFilter} showMoreFilters />
          </div>
          <div className="error-logs-more-filters">
            <ErrorLogsDropdown
              selectedOptions={itemsTypesFilter}
              setSelectedOptions={setItemsTypesFilter}
              checkedOptions={checkedItemsTypes}
              setCheckedOptions={setCheckedItemsTypes}
              options={formatItemsTypeSDropdownOptions}
              title="Bloco"
              placeholder="Selecione os blocos"
            />
            <div className="error-logs-page-by-dropdown">
              <span>Sessão:</span>
              <input
                className="form-control"
                type="text"
                onChange={onChangeSessionIdInput}
                value={sessionId}
                placeholder="{sessionId}"
              />
            </div>
          </div>
        </div>
      </div>
      <ErrorLogsTable tableData={formatItemsTableData()} />
      <div className={classes.root}>
        <Pagination
          count={errorLogs.totalPages}
          page={errorLogs.page}
          size="large"
          variant="outlined"
          onChange={getPage}
        />
      </div>
    </div>
  );
};

export default ErrorLogs;
